import vSelect from "vue-select";

/*****************************************************************************************************
 * Load Window Global
 */
window.Vue = require('vue').default;
window.Vue.use(require('vue-cookies'));
window.MobileDetect = require('mobile-detect');

/*****************************************************************************************************
 * Load jQuery
 */
window.$ = window.jQuery = require('jquery');

/*****************************************************************************************************
 * Load Metabet
 */
window.hasLoadedMetabet = false

/*****************************************************************************************************
 * Load Axios
 */
require('./_axios');
require('@RESOURCES/js/ip-redirect');
// require('select2');
// require('@RESOURCES/js/select2-factory');
require('./_vue_config.js')
require('bootstrap/js/src/modal.js');
require('slick-carousel');

// Vue.component('select2', require('@RESOURCES/js/components/Select2.vue').default);
// Vue.component('loading-spinner', require('@RESOURCES/js/components/LoadingSpinner.vue').default);
Vue.component('region-selector', require('@RESOURCES/js/components/RegionSelector').default);
Vue.component('selector', require('@RESOURCES/js/components/Selector').default);
Vue.component('global-search', require('../../components/Search/GlobalSearch').default);
Vue.component('selector', require('@RESOURCES/js/components/Selector.vue').default);
Vue.component('v-select', vSelect);
/*****************************************************************************************************
 * Load DebugBar from vuejs-components
 */
import { NewsletterForm } from '@kaxmedia/vuejs-components';

Vue.component('newsletter-form', NewsletterForm);

/*****************************************************************************************************
 * Load Table Responsive
 */
import TableResponsive from '@RESOURCES/js/services/table_responsive/TableResponsive';

// debugBarPath = require.resolve('@kaxmedia/vuejs-components') + "/components/DebugBar.vue";

if (document.getElementById('debug')) {
    new Vue({
        el: '#debug',
        components: {
            'debug-bar': () => import('@kaxmedia/vuejs-components/src/components/DebugBar.vue'),
        },
    });
}

new TableResponsive().init();

if (document.getElementsByClassName('global-search-container navigation').length > 0) {
    new Vue({el: ".global-search-container.navigation"})
}
if (document.getElementsByClassName('global-search-container home-banner').length > 0) {
    new Vue({el: ".global-search-container.home-banner"})
}
